import {assert} from "@prosay/common"
import {Platform} from "react-native"

export const atob = (input: string) => {
    if (Platform.OS === "web") {
        // eslint-disable-next-line no-undef
        return window.atob(input)
    }

    const str = input.replace(/=+$/, "")
    let output = ""

    assert(
        str.length % 4 !== 1,
        "'atob' failed: The string to be decoded is not correctly encoded.",
    )

    /* eslint-disable */
    for (
        let bc = 0, bs = 0, buffer, i = 0;
        (buffer = str.charAt(i++));
        ~buffer && ((bs = bc % 4 ? bs * 64 + buffer : buffer), bc++ % 4)
            ? (output += String.fromCharCode(255 & (bs >> ((-2 * bc) & 6))))
            : 0
    ) {
        buffer = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".indexOf(
            buffer,
        )
    }
    /* eslint-enable */

    return output
}
